import { Directive, Input, Renderer2, ElementRef } from '@angular/core';
export class AmdButtonDirective {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set color(theme) {
        this.renderer.addClass(this.elementRef.nativeElement, `amd-button--${theme}`);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.renderer.addClass(this.elementRef.nativeElement, `amd-button`);
        this.renderer.addClass(this.elementRef.nativeElement, `amd-button--default`);
    }
}
AmdButtonDirective.decorators = [
    { type: Directive, args: [{
                selector: '[amdButton]'
            },] },
];
/**
 * @nocollapse
 */
AmdButtonDirective.ctorParameters = () => [
    { type: ElementRef, },
    { type: Renderer2, },
];
AmdButtonDirective.propDecorators = {
    'color': [{ type: Input },],
};
function AmdButtonDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdButtonDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdButtonDirective.ctorParameters;
    /** @type {?} */
    AmdButtonDirective.propDecorators;
    /** @type {?} */
    AmdButtonDirective.prototype.elementRef;
    /** @type {?} */
    AmdButtonDirective.prototype.renderer;
}
//# sourceMappingURL=button.directive.js.map
//# sourceMappingURL=button.directive.js.map
